import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { authService } from '../services/auth.service';

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('Verifying your email address...');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('Invalid verification link. No token provided.');
      return;
    }

    const verify = async () => {
      try {
        const res = await authService.verifyEmail(token);
        setStatus('success');
        setMessage(res.message || 'Email successfully verified! You can now log in.');
      } catch (err: any) {
        setStatus('error');
        setMessage(err.message || 'Failed to verify email. The link may have expired.');
      }
    };

    verify();
  }, [token]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-100 p-4">
      <div className="w-full max-w-md bg-white p-8 rounded-xl shadow-lg border border-gray-100 text-center">
        <img src="/logo-180w.png" className="mx-auto mb-6 w-24 h-24 object-contain" alt="CellySheets Logo" />
        
        <h2 className="text-2xl font-black text-gray-900 mb-6 tracking-tight">Email Verification</h2>

        {status === 'loading' && (
            <div className="flex flex-col items-center justify-center space-y-4 py-4">
                <div className="w-8 h-8 border-4 border-red-200 border-t-red-600 rounded-full animate-spin"></div>
                <p className="text-gray-500 font-medium">{message}</p>
            </div>
        )}

        {status === 'success' && (
            <div className="py-4">
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-green-100 text-green-600 mb-4">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                </div>
                <p className="text-green-800 font-bold mb-8">{message}</p>
                <Link to="/login" className="inline-block w-full py-3 bg-red-600 text-white font-bold rounded-lg hover:bg-red-700 shadow-md transition-all">
                    Proceed to Login
                </Link>
            </div>
        )}

        {status === 'error' && (
            <div className="py-4">
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-red-50 text-red-600 mb-4">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                </div>
                <p className="text-red-700 font-bold mb-8">{message}</p>
                <Link to="/login" className="inline-block w-full py-3 bg-gray-100 text-gray-700 font-bold rounded-lg hover:bg-gray-200 transition-all">
                    Back to Login
                </Link>
            </div>
        )}
      </div>
    </div>
  );
}